import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
	IAuth0ActionPayload,
	IAuth0Authentication,
	IAuthState
} from '../../interfaces';

import authState from './state';

export const authSlice = createSlice({
	initialState: authState,
	name: 'auth',
	reducers: {
		errorReceiveRemoveServerSideCookie: (state: IAuthState) => {
			state.requestingRemoveServerSideCookie = false;
		},
		errorReceiveSetServerSideCookie: (state: IAuthState) => {
			state.requestingSetServerSideCookie = false;
		},
		failedAuth0Authentication: {
			prepare: (error: string) => {
				return { payload: { error } };
			},
			reducer: (state: IAuthState, action: PayloadAction<IAuth0ActionPayload>) => {
				const { error } = action.payload;

				state.auth0Error = error;
			}
		},
		failedReceiveRemoveServerSideCookie: (state: IAuthState) => {
			state.requestingRemoveServerSideCookie = false;
		},
		failedReceiveSetServerSideCookie: (state: IAuthState) => {
			state.requestingSetServerSideCookie = false;
		},
		receiveRemoveServerSideCookie: (state: IAuthState) => {
			state.requestingRemoveServerSideCookie = false;
		},
		receiveSetServerSideCookie: (state: IAuthState) => {
			state.requestingSetServerSideCookie = false;
		},
		requestRemoveServerSideCookie: (state: IAuthState) => {
			state.requestingRemoveServerSideCookie = true;
		},
		requestSetServerSideCookie: {
			prepare: (auth0Authentication: IAuth0Authentication) => {
				return { payload: { auth0Authentication } };
			},
			reducer: (state: IAuthState) => {
				state.requestingSetServerSideCookie = true;
			}
		},
		resetAuth0: () => authState,
		resetUnauthorized: (state: IAuthState) => {
			state.unauthorized = false;
		},
		setUnauthorized: (state: IAuthState) => {
			state.unauthorized = true;
		}
	}
});

export const {
	errorReceiveRemoveServerSideCookie,
	errorReceiveSetServerSideCookie,
	failedAuth0Authentication,
	failedReceiveRemoveServerSideCookie,
	failedReceiveSetServerSideCookie,
	receiveRemoveServerSideCookie,
	receiveSetServerSideCookie,
	requestRemoveServerSideCookie,
	requestSetServerSideCookie,
	resetAuth0,
	resetUnauthorized,
	setUnauthorized
} = authSlice.actions;

export default authSlice.reducer;
